export default {
  'pages.systemConfig.accessTokenRequired': '請輸入訪問令牌',
  'pages.systemConfig.action': '操作',
  'pages.systemConfig.activityDiscountFen': '活動立減(分)',
  'pages.systemConfig.addExitCommand': '新增退出指令',
  'pages.systemConfig.addExternalMcp': '新增外部MCP',
  'pages.systemConfig.addLocalMcpFunction': '新增本地MCP功能',
  'pages.systemConfig.addRole': '新增角色',
  'pages.systemConfig.addSuccess': '新增成功',
  'pages.systemConfig.adminOnly': '請使用管理員賬號進行操作',
  'pages.systemConfig.advancedConfig': '高階配置（點選展開）',
  'pages.systemConfig.annualToken': '年度令牌',
  'pages.systemConfig.appConfigTitle': '應用程式配置',
  'pages.systemConfig.archiveDirPlaceholder': '例如 D:\\\\data\\\\kb_archive 或 /var/lib/kb_archive',
  'pages.systemConfig.archiveDirRequired': '開啟歸檔時請填寫歸檔根目錄',
  'pages.systemConfig.authCardTitle': '認證配置',
  'pages.systemConfig.authorityDomains': '權威域白名單',
  'pages.systemConfig.baiduApiKey': '百度 API Key',
  'pages.systemConfig.baiduEndpoint': '百度端點',
  'pages.systemConfig.bindMemoryToDevice': '記憶繫結裝置',
  'pages.systemConfig.bingEndpoint': 'Bing 端點',
  'pages.systemConfig.bochaApiKey': '博查 API Key',
  'pages.systemConfig.bochaEndpoint': '博查端點',
  'pages.systemConfig.bridgeAckMessage': '外轉成功本地 TTS 提示（可空為靜默）',
  'pages.systemConfig.bridgePanelTitle': 'OpenClaw 橋接',
  'pages.systemConfig.chatAutoRoute': '對話自動路由',
  'pages.systemConfig.commercialDeviceDefaultLlm': '商業授權裝置預設 LLM',
  'pages.systemConfig.commercialLicenseSuffix': '{base}（需商業授權）',
  'pages.systemConfig.configJsonInvalid': '配置內容需為合法的JSON格式',
  'pages.systemConfig.configJsonPlaceholder': '貼上完整的MCP配置JSON',
  'pages.systemConfig.configJsonRequired': '請輸入配置JSON',
  'pages.systemConfig.confirmDeleteExitCommand': '確定刪除這個退出指令嗎？',
  'pages.systemConfig.confirmDeleteExternalMcp': '確定刪除這個外部MCP配置嗎？',
  'pages.systemConfig.confirmDeleteMcpFunction': '確定刪除這個MCP功能嗎？',
  'pages.systemConfig.confirmDeleteQuickReply': '確定刪除該快捷回覆詞嗎？',
  'pages.systemConfig.confirmDeleteRole': '確定刪除這個角色嗎？',
  'pages.systemConfig.continuousSpeechThresholdMs': '連續語音閾值(ms)',
  'pages.systemConfig.dataCardTitle': '資料配置',
  'pages.systemConfig.dataKbAlertDesc': '主地址對應 data-config 的 <code>mcp_rag</code>，用於建庫、檢索、對話 MCP 等。若填寫下方「OCR 索引專用地址」，則與主例項共享同一向量庫時，掃描 PDF 上傳會走 <code>mcp_rag_ocr</code>，減輕主例項負載；兩例項須同版本且主例項提供 <code>/pdf-preflight</code>。',
  'pages.systemConfig.dataKbAlertTitle': '主例項與 OCR 例項（可選）',
  'pages.systemConfig.default1883': '預設1883',
  'pages.systemConfig.default60': '預設 60',
  'pages.systemConfig.defaultPrompt': '預設系統提示詞',
  'pages.systemConfig.delete': '刪除',
  'pages.systemConfig.deleteAudio': '清理臨時音訊',
  'pages.systemConfig.deleteFailed': '刪除失敗: {error}',
  'pages.systemConfig.deleteSuccess': '刪除成功',
  'pages.systemConfig.description': '描述',
  'pages.systemConfig.dialogueHistoryLengthPlaceholder': '0 表示不限制條數',
  'pages.systemConfig.disabledTag': '禁用',
  'pages.systemConfig.domainPlaceholder': '域名',
  'pages.systemConfig.edit': '編輯',
  'pages.systemConfig.emotionRecognitionPrompt': '情緒識別補充提示',
  'pages.systemConfig.asrEmotionDetectionGlobal': 'ASR 情緒檢測全域性開關',
  'pages.systemConfig.enableCommerce': '啟用商業化',
  'pages.systemConfig.enableLabel': '啟用',
  'pages.systemConfig.enableMcpEndpoint': '啟用MCP接入點',
  'pages.systemConfig.enableMcpFilter': '啟用MCP過濾器',
  'pages.systemConfig.enabledTag': '啟用',
  'pages.systemConfig.enterToAdd': '輸入後回車',
  'pages.systemConfig.exitCommandAlertDesc': '服務識別到使用者退出指令，會直接結束對話。',
  'pages.systemConfig.exitCommandAlertTitle': '退出指令說明',
  'pages.systemConfig.exitCommandLength': '退出指令長度應在1-50個字元之間',
  'pages.systemConfig.exitCommandPattern': '退出指令包含不允許的字元',
  'pages.systemConfig.exitCommandRequired': '請輸入退出指令',
  'pages.systemConfig.exitCommandsCardTitle': '退出指令配置',
  'pages.systemConfig.expiryHours': '過期時間(小時)',
  'pages.systemConfig.expiryRequired': '請輸入過期時間',
  'pages.systemConfig.externalMcpAlertDesc': '在此管理外部MCP服務。使用編輯按鈕可以貼上完整的JSON配置，服務會根據名稱儲存對應的MCP服務。',
  'pages.systemConfig.externalMcpAlertTitle': '外部MCP配置說明',
  'pages.systemConfig.externalMcpCardTitle': '外部MCP配置',
  'pages.systemConfig.featureDescLength': '功能描述長度應在5-500個字元之間',
  'pages.systemConfig.featureDescRequired': '請輸入功能描述',
  'pages.systemConfig.featureNameLength': '功能名稱長度應在2-50個字元之間',
  'pages.systemConfig.featureNamePattern': '功能名稱只能包含字母、數字、中文、下劃線和短橫線',
  'pages.systemConfig.featureNameRequired': '請輸入功能名稱',
  'pages.systemConfig.fetchConfigFailed': '獲取{type}配置失敗{detail}: {error}',
  'pages.systemConfig.forceCreateNewConnection': '強制新建連線',
  'pages.systemConfig.forecastDaysLimit': '預報天數上限',
  'pages.systemConfig.todoOverdueGraceMinutes': '待办过期宽限(分钟)',
  'pages.systemConfig.formalApiEndpoint': '正式 API 端點',
  'pages.systemConfig.formalApiKey': '正式 API Key',
  'pages.systemConfig.formalApiProvider': '正式 API 提供商',
  'pages.systemConfig.formalEngine': '正式搜尋引擎',
  'pages.systemConfig.frameDurationMs': '幀長(ms)',
  'pages.systemConfig.info.activateText': '啟用時前端顯示的文字，可以設定為你自己的品牌內容，如“Anime AI Chat”',
  'pages.systemConfig.info.allowedDevices': '暫未實現該功能',
  'pages.systemConfig.info.annualToken': '年度令牌（如有接入年度校驗場景），對應 server.auth.annual_token。',
  'pages.systemConfig.info.bindMemoryToDevice': '開啟後，短期/長期畫像記憶按裝置維度儲存與採集；關閉則按智慧體維度。',
  'pages.systemConfig.info.bridgeOpenClaw': '喵伴↔OpenClaw 橋接總開關與對話自動路由；誤配可能導致每句都外轉，請謹慎開啟。',
  'pages.systemConfig.info.checkDeviceModeImmediately': '裝置模式有chat(聊天模式)/listen(錄音模式)/ban(禁用裝置)，開啟此項後，每次請求llm大模型都會進行檢查，確保修改及時生效。',
  'pages.systemConfig.info.dailyClearQuota': '使用者每次對話，會累計asr、llm、tts的字數，作為使用者的使用額度。開啟此項後，在檢測使用者額度時，如果發現已經是新的一天，會先清除使用者的已用額度。',
  'pages.systemConfig.info.defaultObserverUserOnRegister': '新註冊使用者是否預設分配觀察者角色。觀察者角色的使用者可以檢視web控制後臺的所有資訊，可以自行建立修改llm大模型，用於客戶體驗，不建議開放給普通使用者，如非必須建議關閉。',
  'pages.systemConfig.info.defaultPrompt': '全域性預設系統提示詞（prompt），可被智慧體級配置覆蓋。',
  'pages.systemConfig.info.deleteAudio': '是否在處理完成後刪除臨時音訊檔案；開啟可節省磁碟空間。',
  'pages.systemConfig.info.dialogueHistoryLength': '設定對話歷史的最大長度。每次請求llm會將對話歷史上傳，以便模型參考上下文進行回答。過長的歷史會增加請求延遲和成本，建議根據實際需求設定一個合理的長度。配置為0表示不限長度，會載入本次會話的所有聊天內容。',
  'pages.systemConfig.info.emotionRecognitionPrompt': '智慧體開啟情緒識別時，拼入對話 LLM 的 system 提示片段（驅動【語氣】等標籤）。',
  'pages.systemConfig.info.asrEmotionDetectionGlobal': 'ASR 聲學情緒檢測全域性殺開關。關閉後全量禁用，無視智慧體開關。',
  'pages.systemConfig.info.enableLayeredMemory': '相容舊版「分層記憶」總開關；長期畫像採集主要受智慧體「長期記憶」與下方觀察池配置影響。',
  'pages.systemConfig.info.enableMCPEndPoint': '啟用 MCP 接入點開關。開啟後，前端可透過可見性介面展示 MCP 接入點相關的自定義服務與獲取接入點按鈕（需配合前端與服務端可見性配置實現）。',
  'pages.systemConfig.info.enableMCPFilter': '如果需要限制智慧體使用某些mcp功能，可以開啟此項。llm請求時，只攜帶允許的mcp功能列表。此項需配合Agent的過濾列表一起使用。',
  'pages.systemConfig.info.enableVectorMemory': '開啟後，智慧體可使用向量長期記憶；關閉時即使智慧體選擇長期記憶，也不會寫入或檢索記憶錨點。',
  'pages.systemConfig.info.enableWhiteList': '啟用白名單功能。開啟後，只有白名單中的裝置才能連線到服務端。',
  'pages.systemConfig.info.enhancedEmotionOutput': '增強情感輸出功能。開啟後，LLM的輸出會包含更豐富的情感表達資訊，用於提升對話的情感體驗。',
  'pages.systemConfig.info.expiry': '過期時間（小時），預設24小時有效',
  'pages.systemConfig.info.flattenedChatHistory': '有業務需求再開啟此項。開啟此項後，每句對話會在資料庫(agent_chat_messages表)中保留一條記錄。無論是否開啟此項，每輪對話結束後，都會將聊天曆史儲存在資料庫agent_dialogs表中。',
  'pages.systemConfig.info.forceCreateNewConnection': 'Mqtt/UDP傳輸時，是否強制每次建立新連線。開啟後可以避免某些連線問題，每次新的對話都會載入最新的Agent和Device資訊，修改生效更及時，但會增加伺服器負載，建議根據實際情況選擇。',
  'pages.systemConfig.info.importYamlTab': '僅支援從伺服器匯出當前記憶體中的完整 YAML 供檢視或備份；寫回資料庫功能已關閉，請透過各分項配置頁或直接在資料庫中維護 server_configs。',
  'pages.systemConfig.info.jokeAppCode': '阿里云云市場「笑話大全」API 的 AppCode。',
  'pages.systemConfig.info.keepConversationId': '開啟後每輪對話開始會載入智慧體的會話ID（如已開啟useDeviceConversationID，則會載入裝置的會話ID），並讀取之前的歷史記錄，在此基礎上繼續對話。如果不開啟，每次對話會生成一個新的會話ID，適合需要每次對話獨立的場景。',
  'pages.systemConfig.info.knowledgeBaseMaxDocumentsPerKb': '單個知識庫允許上傳的文件數量上限（寫入 data-config 的 mcp_rag.max_documents_per_knowledge_base）。',
  'pages.systemConfig.info.knowledgeBaseMaxPerUser': '每個使用者允許建立的知識庫數量上限（寫入 data-config 的 mcp_rag.max_knowledge_bases_per_user）。',
  'pages.systemConfig.info.knowledgeBaseOcrApiKey': 'OCR 例項 API Key（寫入 mcp_rag_ocr.api_key），與 mcp-rag security 一致。留空儲存時沿用已儲存的金鑰。',
  'pages.systemConfig.info.knowledgeBaseOcrServerAddr': 'OCR 專用 mcp-rag 的 HTTP 地址（寫入 data-config 的 mcp_rag_ocr.addr）。須與主例項共享同一 Milvus 與後設資料庫；主例項關閉 pdf_ocr_enabled，本例項開啟並安裝 Tesseract。留空則不上傳分流到 OCR 例項。',
  'pages.systemConfig.info.knowledgeBaseOcrTimeoutSeconds': '呼叫 OCR 例項 HTTP 的超時秒數（寫入 mcp_rag_ocr.timeout_seconds），留空或 0 表示由服務端使用預設 60 秒。',
  'pages.systemConfig.info.knowledgeBaseServerAddr': '知識庫伺服器地址，用於配置 zhi-server 連線的 mcp-rag 服務地址。',
  'pages.systemConfig.info.knowledgeBaseUploadArchiveDir': '歸檔根目錄的絕對路徑（寫入 data-config 的 mcp_rag.knowledge_base_upload_archive_dir）。需與上方開關同時啟用；Windows 示例 D:\\\\data\\\\kb_archive，Linux 示例 /var/lib/kb_archive。',
  'pages.systemConfig.info.knowledgeBaseUploadArchiveEnabled': '開啟後，使用者透過控制檯上傳的知識庫原始檔案將按「使用者 ID / 知識庫 ID / 上傳時間」寫入下方歸檔根目錄，便於審計與追溯；關閉則僅使用臨時檔案，上傳至 RAG 成功後即刪除。',
  'pages.systemConfig.info.llmContextLimitEnabled': '開啟後，每次呼叫大模型前按 token 預算裁剪上下文；關閉則完全保持原行為，僅在「每次列印上下文大小」開啟時打觀測日誌。建議先關裁剪觀察日誌，再開啟。',
  'pages.systemConfig.info.llmContextLimitInject': '記憶/知識庫注入段超預算時：head_tail=留頭留尾壓縮；drop_all=整段丟棄。預設 head_tail，緊張時自動降為 drop_all。',
  'pages.systemConfig.info.llmContextLimitLog': '每次呼叫大模型都列印 CTX_LIMIT 上下文大小日誌，便於試執行觀察。穩定後可關閉。',
  'pages.systemConfig.info.llmContextLimitRatio': '輸入預算 = 模型 context_window × 該比例 − 輸出預留。預設 0.70，給回覆留出空間。',
  'pages.systemConfig.info.llmContextLimitReserved': '計算輸入預算時從視窗中減去的輸出預留。填 0 表示使用各模型自己的 max_tokens。僅當希望所有模型統一預留時才改這個值。',
  'pages.systemConfig.info.llmContextLimitStrict': '工具定義精簡時永不摘除的工具名（可帶或不帶 local_ 字首）。',
  'pages.systemConfig.info.mcpPoolConfig': 'MCP 相關連線池引數。',
  'pages.systemConfig.info.toolContentMaxBytes': '工具返回內容寫回對話時的長度上限，超長則保留頭尾各半、中間標註截斷。單位 KB。以下字數按中文估算，若內容是英文/JSON（ASCII）實際可容納約 3 倍字元數：約 2KB≈650 漢字、4KB≈1300 字、6KB≈2000 字、8KB≈2700 字。數值越大保留越完整但每輪消耗 token 越多，建議保持預設。',
  'pages.systemConfig.info.toolContentMaxBytesMap': '按工具名單獨設定上限（KB），未配置的工具使用上方全域性值。常見預置：realtime_search（聯網搜尋）≈2000 字、mcp_rag_ask（知識庫檢索）≈2700 字（字數按中文估算）。可自行新增/修改/刪除條目。',
  'pages.systemConfig.info.memoryCollectionDays': '相容欄位：服務端已不再按天數將畫像設為只讀；寫入僅受「人工鎖定」控制。該數值可保留給舊版介面或觀察池旁註，無業務截斷含義。',
  'pages.systemConfig.info.memoryObservationPoolEnabled': '開啟後，對話採集的身份資訊先入觀察池，跨足夠多會話後再合併入 L1 畫像；關閉則保持每輪直接合並的舊行為。',
  'pages.systemConfig.info.memoryPromotionMinConversations': '觀察池自動晉升所需的最少「不同會話」命中數，建議 2 及以上以降低誤記。',
  'pages.systemConfig.info.middleTierRole': '全域性中間層系統提示（如遮蔽詞/話題約束），僅在與使用者對話的 LLM 請求中接在首條 system 正文末尾。',
  'pages.systemConfig.info.mqttEnabled': '啟用MQTT傳輸方式，客戶端透過mqtt連線到服務端，語音資料透過upd傳輸，速度更快，建議開啟',
  'pages.systemConfig.info.mqttIp': '你的ip:埠（或者域名:埠），埠為外部連入的埠，如未作埠轉發，可以和port相同。這個地址會在ota協議中發給客戶端，由客戶端連線使用。',
  'pages.systemConfig.info.mqttPort': 'mqtt的監聽埠，預設使用1883埠',
  'pages.systemConfig.info.mqttQos': 'MQTT QoS 等級（0/1/2）。',
  'pages.systemConfig.info.notifyDeviceOnMcpTool': '為 true 時，每次執行 MCP/函式工具前向裝置傳送一條 JSON 文字（type=mcp_tool），便於螢幕展示工具名；需裝置韌體支援解析。',
  'pages.systemConfig.info.petMetricsInject': '是否在對話提示詞中向 LLM 注入裝置寵物指標（情緒/親密/活力等）。',
  'pages.systemConfig.info.poolConfig': '通用連線池引數（pool_min_size / pool_max_size 等）。',
  'pages.systemConfig.info.quickReply': '開啟後，針對"你好xx"格式的喚醒詞，可以進行快速回復，提升使用者體驗。回覆的內容配置在快速回複詞中，會隨機選用回覆。建議開啟此項。',
  'pages.systemConfig.info.quickReplyTab': '「你好xx」類喚醒時的隨機短句列表，需與應用配置中「快速回復」開關同時開啟。',
  'pages.systemConfig.info.realtimeSearch': '聯網搜尋（SERP）與正式搜尋 API 相關引數；關閉 Enabled 則不走聯網檢索鏈路。',
  'pages.systemConfig.info.rechargeTab': '裝置流量卡充值、微信支付與物聯平臺一級代理連線引數（對應 recharge 配置塊）。金鑰留空或填 *** 表示不修改原值。',
  'pages.systemConfig.info.recorderManagerEnable': '啟用錄音管理功能。開啟後，管理員可以在後臺檢視裝置的錄音記錄，用於管理和分析。',
  'pages.systemConfig.info.saveTtsAudio': '開啟後會儲存TTS生成的音訊檔案，格式為文字+音色+tts，下次如果請求相同的內容，會直接載入本地的音訊檔案。如硬碟空間有限，建議謹慎開啟，並注意定期清理。',
  'pages.systemConfig.info.saveUserAudio': '開啟後會儲存使用者對話的音訊檔案，用於後續分析和最佳化。如硬碟空間有限，建議謹慎開啟，並注意定期清理。',
  'pages.systemConfig.info.selectedModuleASR': 'selected_module 中當前選用的 ASR 配置塊名稱。',
  'pages.systemConfig.info.selectedModuleLLM': 'selected_module 中當前選用的 LLM 配置塊名稱（與配置裡 LLM 下 key 一致）。',
  'pages.systemConfig.info.selectedModuleLLMCommercial': '建立預設智慧體時，若繫結裝置為商業授權（TenantCode 非空）則選用該 LLM 配置塊名稱；無效時回退到 LLM。',
  'pages.systemConfig.info.selectedModuleLLMOpenSource': '建立預設智慧體時，若繫結裝置為開源（TenantCode 為空）則選用該 LLM 配置塊名稱；無效時回退到 LLM。',
  'pages.systemConfig.info.selectedModuleTTS': 'selected_module 中當前選用的 TTS 配置塊名稱。',
  'pages.systemConfig.info.selectedModuleVLLLM': 'selected_module 中當前選用的視覺模型（VLLLM）配置塊名稱。',
  'pages.systemConfig.info.serverVersion': '服務端對外宣告的版本號字串（server.server_version）。',
  'pages.systemConfig.info.speakerDetect': '啟用聲紋識別功能。開啟後，前端會顯示聲紋識別相關選單和功能，使用者可以使用聲紋識別相關功能。',
  'pages.systemConfig.info.dialogGuardPipeline': '處理順序（誰先攔誰生效）：ASR出字 → L1文字硬規則 → L2說話人硬門 → Echo回聲過濾 → L2.5上下文門 → 主對話LLM(L3 dialog.no_reply)。前幾層是硬攔（不進模型，仍會下發STT到屏，Echo除外）；L3是同一次生成裡模型宣告不回。日誌統一搜：dialog_guard SKIP layer=…。推薦：總開關開 + L1開 +（有聲紋則L2開）+ IntentMerge開 +「僅無聲紋時注入」關 + L2.5與IntentMerge同開。兒童陪伴可在智慧體強制關IntentMerge。',
  'pages.systemConfig.info.dialogGuardEnabled': '【總開關】整條「是否回覆」防護鏈總控。關：L1/L2/L2.5/L3(dialog.no_reply) 都不生效，裝置幾乎有字必回。開：才按 ASR→L1→L2→Echo→L2.5→L3 過門。建議生產常開。',
  'pages.systemConfig.info.textHardRulesEnabled': '【L1】零模型。攔純語氣詞「嗯/哦哦」、無意義單字；放行喚醒詞、助手名、停播口令。依賴總開關。硬攔仍下發STT到裝置屏，不進LLM。日誌 layer=L1。建議常開。',
  'pages.systemConfig.info.speakerGuardEnabled': '【L2】零模型。已鎖定說話人時：別人低相關插話硬跳過，高相關立刻換人。依賴：總開關 + 本開關 +「聲紋識別」開，且本輪聲紋命中；miss時本層幾乎不起作用。日誌 layer=L2。有聲紋錄入時建議開。',
  'pages.systemConfig.info.speakerHotReloadEnabled': '聲紋錄入/刪除後熱重新整理本機線上連線，無需裝置重連。與 L2 說話人硬門配合：新聲紋可更快參與鎖定/換人判斷。',
  'pages.systemConfig.info.speakerQualityCheck': '聲紋錄入前校驗時長、有效語音佔比與 SNR。建議保持開啟以保證註冊質量，從而讓 L2 說話人硬門更可靠。',
  'pages.systemConfig.info.speakerLockTtlSec': '【L2 引數】說話人鎖定時長（秒）。鎖定期內第三方低相關插話會被跳過。',
  'pages.systemConfig.info.speakerLockTtlAfterTtsSec': '【L2 引數】TTS 播報結束後額外延長的鎖定時長（秒），減少播報後被旁人搶走。',
  'pages.systemConfig.info.speakerSwitchConfirmRounds': '【L2 引數】中等相關第三方需連續確認的輪次，達到後才切換對話人；高相關仍可立刻換人。',
  'pages.systemConfig.info.intentMergeEnabled': '【L3】主對話掛載 dialog.no_reply：模型判斷「不是對本裝置說」時可靜默不回（同一次生成，零額外呼叫）。依賴總開關。開了之後灰區應交給模型。儲存即時生效。日誌 layer=L3。建議通用對話開；兒童陪伴可在智慧體強制關。',
  'pages.systemConfig.info.intentMergeOnlyNoSpeaker': '【L3 收緊項】開=僅當裝置無聲紋能力時才注入 no_reply。但若同時開了 L2.5，服務端仍會掛 no_reply（避免灰區既無L3又退回短語硬攔）。推薦：關（有聲紋也掛L3）。灰度試跑才開。',
  'pages.systemConfig.info.intentMergePrompt': '【L3 提示詞】拼入主對話的「是否回覆」規則。原則應是：拿不準就回復；僅高置信旁人互聊/寒暄才 no_reply。留空儲存會回填服務端預設文案；過嚴舊文案會自動升級。',
  'pages.systemConfig.info.contextGateEnabled': '【L2.5】零模型上下文門。與 L3 關係：若已開 IntentMerge，L2.5 不再靠短語名單硬攔，灰區交 L3；未開 IntentMerge 時才用寒暄/媒體旁白等廉價規則兜底。依賴總開關。日誌 layer=L2.5。推薦與 IntentMerge 一起開。',
  'pages.systemConfig.info.contextGateRecentTurns': '【L2.5 引數】判定「接續上文」時參考的最近對話輪數。接續命中則放行進主對話。預設 2；調大更易放行。',
  'pages.systemConfig.info.contextGateShortCjk': '【L2.5 引數】CJK 短句字數閾值（歷史相容項）。當前有 IntentMerge 時灰區主要交 L3，該閾值影響變小。預設 12。',
  'pages.systemConfig.info.contextGateShortLatin': '【L2.5 引數】拉丁語短句詞數閾值（歷史相容項）。有 IntentMerge 時影響變小。預設 8。',
  'pages.systemConfig.info.staticDir': 'Web 靜態資源目錄（web.static_dir）。',
  'pages.systemConfig.info.storeType': '認證儲存型別：memory（記憶體）/ file / redis 等，與 config.yaml 中 server.auth.store.type 一致。',
  'pages.systemConfig.info.submitAgentIdToLLM': '開啟此項後，請求llm時，會在使用者角色的對話內容尾部新增額外資訊：[系統資訊: 智慧體ID={agentId}，裝置ID={deviceId}]，某些模型可能會利用這些資訊最佳化回答。',
  'pages.systemConfig.info.token': 'Token用於客戶端的簽名認證，也用於基於openid的服務端轉發請求驗證',
  'pages.systemConfig.info.toutiaoAppCode': '阿里云云市場「新聞頭條」API 的 AppCode。',
  'pages.systemConfig.info.udpEnableReliability': '是否啟用 UDP 可靠性相關擴充套件（依韌體與服務端實現）。',
  'pages.systemConfig.info.udpIp': '你的伺服器公網IP地址，客戶端透過udp連線到服務端。這個地址會透過hello訊息發給客戶端，由客戶端連線使用。',
  'pages.systemConfig.info.udpMaxPacketSize': 'UDP 單包最大位元組數。',
  'pages.systemConfig.info.udpPort': 'UPD傳輸的監聽埠，預設使用8100埠',
  'pages.systemConfig.info.udpSessionTimeout': 'UDP 會話超時時間字串，如 30s。',
  'pages.systemConfig.info.udpShowPort': '發給客戶端的UPD埠，通常和udpPort相同，不用特別修改。如果你的伺服器有埠轉發，可以設定為轉發前的埠。',
  'pages.systemConfig.info.useDeviceCode': '是否啟用裝置程式碼功能。啟用後新註冊的每臺裝置會生成一個6位數字的裝置程式碼，目前dify大模型需要這個程式碼作為使用者標識，如需使用dify，建議開啟此項。',
  'pages.systemConfig.info.useDeviceConversationID': '會話ID預設繫結到Agent智慧體，用於載入歷史對話，所有繫結該智慧體的裝置共用一個會話ID。但某些情況需要每個裝置單獨維護會話ID，如需每個裝置單獨維護會話ID，請開啟此項。',
  'pages.systemConfig.info.useShortTermMemory': '開啟後，系統使用短期記憶機制，每輪對話後更新短期記憶。關閉則不使用短期記憶。',
  'pages.systemConfig.info.userTotalQuota': '使用者總額度，0表示不限制額度。使用者使用額度如果超過總額度，將無法繼續對話，提示使用者“今日額度已用完，請聯絡管理員”',
  'pages.systemConfig.info.vadInterrupt': '本地幀級 VAD 打斷：realtime 模式下使用者開口可儘快停止 TTS/LLM，與 gRPC 切段 VAD 並行。',
  'pages.systemConfig.info.validTokens': '有效的Token列表，暫未實現該功能',
  'pages.systemConfig.info.visionPrompt': '視覺識別提示詞字首（vision_prompt），服務端 /vision 呼叫 VLLLM 時注入。',
  'pages.systemConfig.info.visionUrl': '用於前端照片視覺識別的地址，一般為https://你的域名/api/vision，或者http://你的ip:8080/api/vision',
  'pages.systemConfig.info.voiceCloneCommerce': '音色克隆商業化：次數包、微信支付價格與限購等（與 recharge 模組配合）。',
  'pages.systemConfig.info.voiceCloneEnable': '開啟後，前端將顯示聲音克隆相關功能。',
  'pages.systemConfig.info.weatherAppCode': '阿里云云市場「七天天氣預報」API 的 AppCode。',
  'pages.systemConfig.info.weatherForecastDays': '多日天氣預報最多返回天數（0 表示不按配置截斷）。',
  'pages.systemConfig.info.todoOverdueGraceMinutes': '待办提醒过期后的宽限分钟数：超过后周期待办推进下一轮，一次性待办自动完成。默认 60。',
  'pages.systemConfig.info.webPort': 'Web服務監聽的埠，預設使用8080埠，確保該埠未被佔用',
  'pages.systemConfig.info.webSocketEnabled': '啟用WebSocket傳輸方式，客戶端透過wss/ws連線到服務端，連線穩定，建議開啟',
  'pages.systemConfig.info.websocketAddress': 'ota請求時傳送給前端的WebSocket地址，一般為wss://你的域名/ws，或者ws://你的ip:8080/ws',
  'pages.systemConfig.info.xiaozhiApiDomain': '小智相關 API 域名（xiaozhi.api_domain），用於 OTA/對接等場景。',
  'pages.systemConfig.injectPetMetricsToLlm': '注入寵物指標到 LLM',
  'pages.systemConfig.intentKeywords': '意圖關鍵詞（子串匹配，回車新增）',
  'pages.systemConfig.ipAddress': 'IP地址',
  'pages.systemConfig.jokeAppCode': '笑話 AppCode',
  'pages.systemConfig.kbUploadArchiveDir': '知識庫上傳歸檔根目錄',
  'pages.systemConfig.keepConversationId': '保持會話ID',
  'pages.systemConfig.kbUnit': 'KB',
  'pages.systemConfig.toolContentMapAdd': '新增工具',
  'pages.systemConfig.toolContentMapKbPlaceholder': 'KB',
  'pages.systemConfig.toolContentMapToolNamePlaceholder': '工具名（如 realtime_search）',
  'pages.systemConfig.toolContentMaxBytes': '工具內容長度上限(KB)',
  'pages.systemConfig.toolContentMaxBytesMap': '工具差異化上限',
  'pages.systemConfig.toolContentMaxBytesMin': '至少 1KB（約 320 字）',
  'pages.systemConfig.toolContentMaxBytesPlaceholder': '2 ≈ 約650字',
  'pages.systemConfig.knowledgeBaseDivider': '知識庫',
  'pages.systemConfig.knowledgeBaseMaxDocumentsPerKb': '單庫文件數量上限',
  'pages.systemConfig.knowledgeBaseMaxPerUser': '每使用者知識庫數量上限',
  'pages.systemConfig.knowledgeBaseServerAddr': '知識庫伺服器地址',
  'pages.systemConfig.knowledgeBaseServerAddrPlaceholder': '請輸入知識庫伺服器地址，如：http://localhost:8060',
  'pages.systemConfig.layeredMemory': '分層記憶（相容）',
  'pages.systemConfig.listenPortRequired': '請填寫監聽埠',
  'pages.systemConfig.llmCommercialDefault': 'LLM（商業預設）',
  'pages.systemConfig.llmContextLimit': '大模型上下文限制',
  'pages.systemConfig.llmContextLimitEnabled': '啟用上下文裁剪',
  'pages.systemConfig.llmContextLimitInject': '注入段策略',
  'pages.systemConfig.llmContextLimitLog': '每次列印上下文大小',
  'pages.systemConfig.llmContextLimitRatio': '視窗使用比例',
  'pages.systemConfig.llmContextLimitReserved': '輸出預留 Token',
  'pages.systemConfig.llmContextLimitReservedPlaceholder': '0 = 使用各模型 max_tokens',
  'pages.systemConfig.llmContextLimitStrict': '工具白名單（永不精簡）',
  'pages.systemConfig.llmCtxDiary': '日記生成預算',
  'pages.systemConfig.llmCtxIdentity': '身份採集預算',
  'pages.systemConfig.llmCtxMeeting': '會議摘要預算',
  'pages.systemConfig.llmCtxRewrite': '搜尋詞改寫預算',
  'pages.systemConfig.llmCtxSummary': '記憶總結預算',
  'pages.systemConfig.llmCtxTitle': '標題生成預算',
  'pages.systemConfig.llmOpenSourceDefault': 'LLM（開源預設）',
  'pages.systemConfig.loadFailed': '載入失敗: {error}',
  'pages.systemConfig.logAlertDesc': '更改日誌配置後需要重啟服務才能生效。',
  'pages.systemConfig.logAlertTitle': '日誌配置說明',
  'pages.systemConfig.logCardTitle': '日誌配置',
  'pages.systemConfig.logDirPlaceholder': '日誌檔案目錄',
  'pages.systemConfig.logDirRequired': '請輸入日誌目錄',
  'pages.systemConfig.logFileNameRequired': '請輸入日誌檔名',
  'pages.systemConfig.logLevelRequired': '請選擇日誌級別',
  'pages.systemConfig.masterSwitch': '總開關',
  'pages.systemConfig.maxPacketSize': '最大包長',
  'pages.systemConfig.mcpFunctionsAlertDesc': '本地MCP是服務內建的功能，目前僅支援 time、exit、play_music、switch_agent，更多功能需要等待伺服器更新新增。',
  'pages.systemConfig.mcpFunctionsAlertTitle': '本地MCP功能說明',
  'pages.systemConfig.mcpFunctionsCardTitle': '本地MCP功能配置',
  'pages.systemConfig.mcpNamePlaceholder': '例如：Home Assistant',
  'pages.systemConfig.mcpNameRequired': '請輸入MCP名稱',
  'pages.systemConfig.memoryCollectionDays': '記憶收集期（天）',
  'pages.systemConfig.memoryCollectionDaysPlaceholder': '0 表示不按天限制',
  'pages.systemConfig.middleTierRole': '中間層約束提示',
  'pages.systemConfig.minEvidence': '最少證據條數',
  'pages.systemConfig.miscPanelTitle': '雲市場 AppCode / 寵物指標',
  'pages.systemConfig.modalAddTitle': '新增{target}',
  'pages.systemConfig.modalEditTitle': '編輯{target}',
  'pages.systemConfig.modalTarget.externalMcp': '外部MCP',
  'pages.systemConfig.modalTarget.localMcpFunction': '本地MCP功能',
  'pages.systemConfig.modalTarget.quickReplyWord': '快捷回覆詞',
  'pages.systemConfig.modalTarget.role': '角色',
  'pages.systemConfig.mqttConfig': 'MQTT配置',
  'pages.systemConfig.mqttListenPort': 'MQTT監聽埠',
  'pages.systemConfig.nameMaxLength': '名稱長度不能超過80個字元',
  'pages.systemConfig.noDescription': '暫無描述',
  'pages.systemConfig.noLimitPlaceholder': '0表示不限制',
  'pages.systemConfig.notifyDeviceOnMcpTool': 'MCP 工具前通知裝置',
  'pages.systemConfig.observationPool': '長期記憶觀察池',
  'pages.systemConfig.ocrApiKey': 'OCR 例項 API Key',
  'pages.systemConfig.ocrApiKeyPlaceholder': '留空儲存則不改寫已儲存的金鑰',
  'pages.systemConfig.ocrDivider': '知識庫 OCR 索引專用例項（可選）',
  'pages.systemConfig.ocrServerAddr': 'OCR 索引服務地址',
  'pages.systemConfig.ocrServerAddrPlaceholder': '留空則不啟用；例如 http://127.0.0.1:8061',
  'pages.systemConfig.ocrTimeoutSeconds': 'OCR 例項 HTTP 超時（秒）',
  'pages.systemConfig.openSourceDeviceDefaultLlm': '開源裝置預設 LLM',
  'pages.systemConfig.operationFailed': '操作失敗',
  'pages.systemConfig.operationFailedDetail': '操作失敗: {detail}',
  'pages.systemConfig.optional': '可選',
  'pages.systemConfig.originalListPriceFen': '劃線原價(分)',
  'pages.systemConfig.pageAlertDesc': '在這裡您可以管理系統的各項配置，包括應用程式設定、伺服器配置、認證設定等。修改配置後請及時儲存。',
  'pages.systemConfig.pageAlertTitle': '配置管理說明',
  'pages.systemConfig.pageSubtitle': '管理系統的各項配置引數',
  'pages.systemConfig.pageTitle': '系統配置管理',
  'pages.systemConfig.pendingOrderLimitPerUser': '每使用者待支付訂單上限',
  'pages.systemConfig.poolCheckInterval': '檢查間隔',
  'pages.systemConfig.poolMaxSize': '最大',
  'pages.systemConfig.poolMinSize': '最小',
  'pages.systemConfig.poolPanelTitle': '連線池（pool_config / mcp_pool_config）',
  'pages.systemConfig.poolRefillSize': '補滿批次',
  'pages.systemConfig.poolRefillSizeMcp': 'refill 批次',
  'pages.systemConfig.portNotZeroPlaceholder': '請填寫埠號，不能為0',
  'pages.systemConfig.portRequired': '請輸入埠',
  'pages.systemConfig.priceFen': '售價(分)',
  'pages.systemConfig.promotionMinConversations': '觀察池晉升最少會話數',
  'pages.systemConfig.quantityRequired': '請輸入數量',
  'pages.systemConfig.quickReply.addWord': '新增回複詞',
  'pages.systemConfig.quickReplyCardTitle': '快捷回覆詞',
  'pages.systemConfig.quickReplyWordRequired': '請輸入快捷回覆詞',
  'pages.systemConfig.quotaNonNegative': '額度不能為負數',
  'pages.systemConfig.quotaPerPurchase': '每單次數',
  'pages.systemConfig.recharge.apiV3Key': 'APIv3 金鑰（留空或 *** 不改）',
  'pages.systemConfig.recharge.cardTitle': '充值與微信支付',
  'pages.systemConfig.recharge.certSerialNo': '商戶證書序列號',
  'pages.systemConfig.recharge.disableRefundOnSimFail': '物聯充值失敗時不自動微信退款',
  'pages.systemConfig.recharge.enabled': '啟用充值模組',
  'pages.systemConfig.recharge.feeBearer': '手續費承擔 platform|user',
  'pages.systemConfig.recharge.feeRate': '費率 fee_rate',
  'pages.systemConfig.recharge.mchId': '商戶號 mch_id',
  'pages.systemConfig.recharge.notifyUrl': '支付結果 notify_url',
  'pages.systemConfig.recharge.privateKeyPath': '商戶私鑰 PEM 路徑',
  'pages.systemConfig.recharge.refundNotifyUrl': '退款 notify_url（可選）',
  'pages.systemConfig.recharge.simPlatformsDivider': '物聯平臺 sim_platforms（JSON）',
  'pages.systemConfig.recharge.simPlatformsJson': '一級代理配置物件 JSON',
  'pages.systemConfig.recharge.simPlatformsJsonInvalid': '需為合法 JSON 物件',
  'pages.systemConfig.recharge.wechatEnabled': '啟用微信支付',
  'pages.systemConfig.recharge.wechatPayDivider': '微信支付 wechat_pay',
  'pages.systemConfig.recharge.wechatPublicKeyId': '微信支付公鑰 ID',
  'pages.systemConfig.recharge.wechatPublicKeyPath': '微信支付公鑰 PEM 路徑',
  'pages.systemConfig.reliabilityExtension': '可靠性擴充套件',
  'pages.systemConfig.reloadFailed': '過載失敗: {error}',
  'pages.systemConfig.reloadFailedMsg': '過載失敗',
  'pages.systemConfig.reloadVoiceScripts': '過載話術庫快取',
  'pages.systemConfig.renamePlaceholder': '如需重新命名請輸入新名稱',
  'pages.systemConfig.replyWord': '回覆詞',
  'pages.systemConfig.replyWordPlaceholder': '如：我在',
  'pages.systemConfig.replyWordRequired': '請輸入回覆詞',
  'pages.systemConfig.requirePaymentForClone': '克隆需先購買',
  'pages.systemConfig.retryCount': '重試次數',
  'pages.systemConfig.roleDescLength': '角色描述長度應在5-500個字元之間',
  'pages.systemConfig.roleDescRequired': '請輸入角色描述',
  'pages.systemConfig.roleNameLength': '角色名稱長度應在2-50個字元之間',
  'pages.systemConfig.roleNamePattern': '角色名稱只能包含字母、數字、中文、下劃線和短橫線',
  'pages.systemConfig.roleNameRequired': '請輸入角色名稱',
  'pages.systemConfig.rolesCardTitle': '角色配置',
  'pages.systemConfig.routeAllSentences': '每句外轉(慎用)',
  'pages.systemConfig.rsPanelTitle': '聯網搜尋（realtime_search）',
  'pages.systemConfig.sampleRate': '取樣率',
  'pages.systemConfig.saveAppConfig': '儲存應用配置',
  'pages.systemConfig.saveConfig': '儲存配置',
  'pages.systemConfig.saveConfigSuccess': '配置儲存成功',
  'pages.systemConfig.saveFailed': '儲存失敗: {error}',
  'pages.systemConfig.saveKbUploadOriginal': '儲存知識庫上傳原始檔案',
  'pages.systemConfig.saveTtsAudio': '儲存TTS音訊',
  'pages.systemConfig.selectLlmConfigName': '選擇 LLM 配置名',
  'pages.systemConfig.selectedModuleDivider': 'selected_module（當前選用模組名）',
  'pages.systemConfig.serpEngines': 'SERP 引擎列表',
  'pages.systemConfig.serpEnginesPlaceholder': '如 baidu、360',
  'pages.systemConfig.serpStrategy': 'SERP 策略',
  'pages.systemConfig.serverVersion': '服務版本號',
  'pages.systemConfig.sessionTimeout': '會話超時',
  'pages.systemConfig.sessionTimeoutPlaceholder': '如 30s',
  'pages.systemConfig.showPortNotZero': '埠號不能為0，請填寫有效埠',
  'pages.systemConfig.showPortRequired': '請填寫顯示埠',
  'pages.systemConfig.silenceResetMs': '靜音重置(ms)',
  'pages.systemConfig.simPlatformsJsonError': '物聯平臺 JSON 解析失敗，請檢查 simPlatformsJson',
  'pages.systemConfig.sortWeight': '排序權重',
  'pages.systemConfig.speakerRecognizeAddr': '聲紋識別伺服器地址',
  'pages.systemConfig.speakerRecognizeAddrPlaceholder': '請輸入聲紋識別伺服器地址，如：localhost:8848',
  'pages.systemConfig.speakerRecognizeDivider': '聲紋識別',
  'pages.systemConfig.staticDir': '靜態資源目錄',
  'pages.systemConfig.staticDirPlaceholder': '如 ./static 或 web.static_dir',
  'pages.systemConfig.statusColumn': '狀態',
  'pages.systemConfig.storeType': '儲存型別',
  'pages.systemConfig.storeTypeRequired': '請選擇或填寫儲存型別',
  'pages.systemConfig.submitAgentIdToLlm': '向LLM提交Agent ID',
  'pages.systemConfig.switchOff': '關閉',
  'pages.systemConfig.switchOn': '開啟',
  'pages.systemConfig.tab.application': '應用配置',
  'pages.systemConfig.tab.auth': '認證配置',
  'pages.systemConfig.tab.data': '資料配置',
  'pages.systemConfig.tab.exitCommands': '退出指令',
  'pages.systemConfig.tab.externalMcp': '外部MCP配置',
  'pages.systemConfig.tab.localMcp': '本地MCP功能',
  'pages.systemConfig.tab.log': '日誌配置',
  'pages.systemConfig.tab.quickReply': '快捷回覆',
  'pages.systemConfig.tab.recharge': '充值/支付',
  'pages.systemConfig.tab.roles': '角色配置',
  'pages.systemConfig.tab.transport': '傳輸配置',
  'pages.systemConfig.tab.web': 'Web配置',
  'pages.systemConfig.tab.yaml': '完整YAML（只讀）',
  'pages.systemConfig.timeoutSec': '超時(秒)',
  'pages.systemConfig.toutiaoAppCode': '頭條 AppCode',
  'pages.systemConfig.transportCardTitle': '傳輸層配置',
  'pages.systemConfig.transportLayerTitle': '{name} 傳輸層',
  'pages.systemConfig.udpConfig': 'UDP配置',
  'pages.systemConfig.udpListenPort': 'UDP監聽埠',
  'pages.systemConfig.updateSuccess': '更新成功',
  'pages.systemConfig.useDeviceConversationId': '使用裝置會話ID',
  'pages.systemConfig.vadPanelTitle': 'VAD 打斷（vad_interrupt）',
  'pages.systemConfig.validPortRequired': '請填寫有效埠',
  'pages.systemConfig.vccPanelTitle': '音色克隆商業化（voice_clone_commerce）',
  'pages.systemConfig.vectorMemory': '向量長期記憶',
  'pages.systemConfig.visionPromptPrefix': '視覺提示詞字首',
  'pages.systemConfig.visionServiceUrl': '視覺服務URL',
  'pages.systemConfig.voiceScriptsReloaded': '話術庫已過載（意圖 {intents}，條目 {entries}）',
  'pages.systemConfig.weatherAppCode': '天氣 AppCode',
  'pages.systemConfig.webCardTitle': 'Web介面配置',
  'pages.systemConfig.webServicePort': 'Web服務埠',
  'pages.systemConfig.webrtcVadMode': 'WebRTC VAD 模式(0-3)',
  'pages.systemConfig.websocketAddress': 'WebSocket地址',
  'pages.systemConfig.websocketAddressRequired': '請輸入WebSocket地址',
  'pages.systemConfig.websocketPlaceholder': 'ws://你的ip:8000',
  'pages.systemConfig.xiaozhiApiDomain': '小智 API 域名',
  'pages.systemConfig.yaml.cardTitle': '完整 YAML（server_configs，只讀）',
  'pages.systemConfig.yaml.loadBtn': '從伺服器載入',
  'pages.systemConfig.yaml.placeholder': '點選「從伺服器載入」檢視當前配置',
  'pages.systemConfig.yamlAlignedExtras': '與 server_configs / YAML 對齊的擴充套件項',
  'pages.systemConfig.yamlLoadedSuccess': '已從伺服器載入當前 YAML',
  'pages.systemConfig.navigationAmapKey': '導航高德 Key',
  'pages.systemConfig.info.navigationAmapKey': '高德 Web 服務 Key（駕車路線規劃導航）。用於 navigation_route 工具。留空則降級複用 location_report 的高德 Key。',
  'pages.systemConfig.yourIp': '你的IP',
};
